import { STAGE_META } from '../../lib/workflow';

export const StagePill = ({ stage, size = 'sm', testId }) => {
  const m = STAGE_META[stage];
  if (!m) return null;
  const pad = size === 'xs' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-[11px]';
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full border font-semibold whitespace-nowrap ${pad} ${m.cls}`}
    >
      <span aria-hidden>{m.emoji}</span>
      {m.label}
    </span>
  );
};
